import * as React from "react";
import "../../../../assets/scss/components/toc/orderPlacement/opLayout/opLayoutDsk.scss";
import "../../../../assets/scss/components/toc/orderPlacement/opLayout/opLayoutTab.scss";
import "../../../../assets/scss/components/toc/orderPlacement/opLayout/opLayoutMob.scss";

export interface OpLayoutProps {
	quoteComp: React.ReactNode;
}

const OpLayout: React.FC<OpLayoutProps> = (props) => {
	return <div className="op_layout">
		<div className="quote_cont">{props.quoteComp}</div>
		<div className="op_form_cont"></div>
	</div>;
};

export default OpLayout;
